import { render, staticRenderFns } from "./RedeemCodeGiftDetailsDialog.vue?vue&type=template&id=64608c55&scoped=true"
import script from "./RedeemCodeGiftDetailsDialog.vue?vue&type=script&lang=js"
export * from "./RedeemCodeGiftDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./RedeemCodeGiftDetailsDialog.vue?vue&type=style&index=0&id=64608c55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64608c55",
  null
  
)

export default component.exports